﻿import $ from 'jquery';

declare global {
  interface JQuery {
    autorequest(option, args): any;
  }
}
export class AutoRequest {
  public static get wireup(): string {
    return '[data-autorequest]'
  }

  private get timeoutDataAttribute(): string {
    return 'autorequest-' + this.options.id;
  }

  private DEFAULTS: AutoRequestOptions = {
    id: null,
    timeout: 0
  };

  private $element: JQuery;
  private options: AutoRequestOptions;

  public constructor($element: JQuery, options: AutoRequestOptions) {
    if (!$element && $element.length != 1)
      throw new Error('You must provide a single element to Rustig.Autorequest');

    this.$element = $element;
    this.options = $.extend({}, this.DEFAULTS, $element.data(), options);
    this.configureId();

    this.scheduleRemoteRequest();
  }

  private configureId(): void {
    if (this.options.id)
      return;

    this.options.id = this.$element.data('autorequest');
        
    if (this.options.id == 'on')
      this.options.id = this.$element.data('url') || this.$element.data('documentlink');

    if (this.options.id == null)
      throw new Error('Autorequest requires an id to be set');
  }

  private scheduleRemoteRequest(): void {
    this.options.timeout = this.options.timeout || this.DEFAULTS.timeout;
    this.cancelPreviousTimeoutIfNeeded();

    let executeFunc = this.$element.data('documentlink')
      ? this.executeClick.bind(this)
      : this.executeRemote.bind(this);

    let timeoutId = window.setTimeout(executeFunc, this.options.timeout)
    this.storeTimeout(timeoutId);
  }

  private cancelPreviousTimeoutIfNeeded() {
    let timeoutId = $(document).data(this.timeoutDataAttribute);

    if (!timeoutId)
      return;

    window.clearTimeout(timeoutId);
  }

  private storeTimeout(timeoutId: number) {
    $(document).data(this.timeoutDataAttribute, timeoutId);
  }

  private executeClick(): void {
    this.$element.click();
  }

  private executeRemote(): void {

    this.$element.remote();
  }
}

export interface AutoRequestOptions {
  id: string,
  timeout?: number,
}

function Plugin(option, args) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.autorequest');
    let options = typeof option == 'object' && option;

    if (!data) {
      data = new AutoRequest($this, options);
      $this.data('rustig.autorequest', data);
    }
    if (typeof option == 'string')
      data[option]();
  });
}

$.fn.autorequest = Plugin;
